import { getRequest } from "./tools/httpRequests";

export class CommonApi {
  getCurrencyList = () => {};

  getCountries_api = async () => {
    return await getRequest("master/api_countries", {});
  };

  getStates_api = async (props: { country: string }) => {
    return await getRequest("master/api_states", props);
  };

  getCities_api = async (props: { state: string }) => {
    return await getRequest("master/api_cities", props);
  };

  static getDbCities = async (props: { city: string }) => {
    return await getRequest("master/dbCities", props);
  };

  static getDbCityByCityId = async (props: { cityId: number }) => {
    return await getRequest("master/dbCities", props);
  };
}
